// @flow

import React from 'react';
import PropTypes from 'prop-types';
import ProjectContentDescription from '../ContentDescription';
import Tooltip from '../../../../../Resources/Common/Tooltip';

export default function ActionPlan(props) {
  const { proposalUid, hasRights, blocked } = props;
  return (
    <ProjectContentDescription
      title="Plan d'action"
      tooltip={Tooltip.ProjectOfferActionPlan.description}
      proposalUid={proposalUid}
      hasRights={hasRights}
      blocked={blocked}
    />
  );
}

ActionPlan.propTypes = {
  hasRights: PropTypes.bool.isRequired,
  blocked: PropTypes.bool.isRequired,
  proposalUid: PropTypes.string
};

ActionPlan.defaultProps = {
  proposalUid: undefined
};
